<template>
  <div ref="menuRef" class="relative flex items-center justify-end">
    <Button
        variant="ghost-no-padding"
        class="hover-lift-no-shadow"
        @click="toggleMenu"
    >
      <span class="underline">{{ __('See all') }}</span>
    </Button>

    <transition
        enter-active-class="transition-all duration-150 ease-out"
        enter-from-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="transition-all duration-100 ease-in"
        leave-from-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div
          v-if="showMenu"
          class="absolute top-8 right-0 z-50 min-h-44 overflow-y-auto w-64 rounded-lg border bg-white shadow-lg"
      >
        <ul class="p-4 space-y-4 text-sm text-gray-700">
          <li
              v-for="member in data"
              :key="member.id"
              class="flex items-center gap-3 rounded-lg"
              :class="member.is_creator ? 'bg-[#f2e7ff] py-1.5 pl-1 -ml-1' : ''"
          >
            <img
                class="w-8 h-8 rounded-full"
                :src="member.profile_picture_url"
                alt=""
            />
            <span class="truncate">
              {{ member.first_name }} {{ member.last_name }}
            </span>
            <span>
              <Icon
                  v-if="member.is_creator"
                  name="wand_shine"
                  class="text-zinc-800"
              />
            </span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { Button} from "@/components/block/button";
import { __ } from '@/helpers';
import { Icon } from '@/components/block/icon';

const showMenu = ref(false);
const menuRef = ref(null);
const toggleMenu = () => {
  showMenu.value = !showMenu.value;
};
const props = defineProps({
  data: Object
});
function handleClickOutside(event) {
  if (menuRef.value && !menuRef.value.contains(event.target)) {
    showMenu.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>
